import script from "./Cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cards.vue?vue&type=script&setup=true&lang=ts"

import "./Cards.vue?vue&type=style&index=0&id=8100b0a8&scoped=true&lang=scss"

import exportComponent from "/tmp/plasty-fe-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8100b0a8"]])

export default __exports__